import React, { Component, PropTypes  } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as R from 'ramda';
import * as ducks from './ducks';
import * as selectors from './selectors';
import classNames from 'classnames/bind';
import moment from 'moment'

const signalR = require("@aspnet/signalr");

import {
} from 'actions';

import styles from './styles.css';
const cx = classNames.bind(styles);

/**
 *  Контейнер Notifications.
 *  Используется для отображения Notifications
 *
 */
class Notifications extends Component {

	static propTypes = {

	}

	state = {
		isOpenReaded: false
	}

	componentDidMount() {
		const {dispatch} = this.props;
		dispatch(ducks.getNotificationsList());
		this.updateMessage();
		window.addEventListener('click', this.handleDocumentClick);
	}

	componentWillUnmount () {
		window.removeEventListener('click', this.handleDocumentClick);
		this.connection.stop().then(()=> {
		}).catch(err => console.log(err));
	}

	handleDocumentClick = (evt) => {
		const {isOpen} = this.props;
		const area = this.refs.notifications;
		if (isOpen && area && !area.contains(evt.target)) {
			this.props.dispatch(ducks.toggleCard(false));
		}
	}


	componentDidUpdate(prevProps){
		const {notify, isOpen} = this.props;
		if(notify.unReadList.length && isOpen && (isOpen !== prevProps.isOpen)){
			this.listenToReadMessage();
		}
	}

	openCard = (e) => {
		const {dispatch, isOpen } = this.props;
		dispatch(ducks.toggleCard(true));
	}

	closeCard = () => {
		const {dispatch} = this.props;
		dispatch(ducks.toggleCard(false));
	}

	updateMessage() {
		const {dispatch,  userInfo} = this.props;
		this.connection = new signalR.HubConnectionBuilder()
			.withUrl('https://health.todayme.ru/chat')
			.withAutomaticReconnect()
			.configureLogging(signalR.LogLevel.Debug)
			.build();
		this.connection.on('Send', message => {
			if (message === 'update_notifications') {
				dispatch(ducks.getNotificationsList())
			}
		});

		this.connection.start().then(() => {
			return this.connection.invoke('ConnectUser',  userInfo.data.id)
		}).catch(err => console.log(err));
	}

	listenToReadMessage = () => {
		const {userInfo, dispatch} = this.props;
		if(this.connection) {
			this.connection.invoke('NotificationsSetRead', userInfo.data.id);
			dispatch(ducks.setUnReadMessage())
		}
	}

	toggleReaded = () => {
		this.setState({
			isOpenReaded: !this.state.isOpenReaded
		})
	}
	render() {
		const { isOpen, userInfo, notify, unReadMessage } = this.props;
		return (
			<div ref='notifications' className={cx('notifications', {
				'wide': isOpen
			})}>
				<div className={cx('bell', {'isOpen': isOpen})} onClick={this.openCard}>
					<svg className={cx('icon-bell')}>
						<use xlinkHref='#bell'/>
					</svg>
					{unReadMessage && !isOpen ? <div className={cx('amount')}><span>{unReadMessage}</span></div> : null}
				</div>
				{
					isOpen &&
						<div className={cx('card')}>
							<div className={cx('title')}>
								<div>Уведомления</div>
								<div className={cx('close')} onClick={this.closeCard}>
									<svg className={cx('icon-close')}>
										<use xlinkHref='#close'/>
									</svg>
								</div>
							</div>
							<div className={cx('content')}>

								<div className={cx('list')}>
									{
										notify.unReadList.map((item) => {
											return (
												<div className={cx('item')} key={item.id}>
													<div className={cx('photo')}>
														<img src={item.photo} alt=""/>
													</div>
													<div className={cx('info')}>
														<div className={cx('header-item')}>
															<span className={cx('text')}>{item.achievement}</span>
															<span className={cx('value')}>{parseInt(item.points) < 0 ? item.points : `+${item.points}`}</span>
														</div>
														<div className={cx('desc')}>{item.text}</div>
														<div className={cx('date')}>{moment(item.createTs).format('lll')}</div>
													</div>
												</div>
											)
										})
									}

									{ notify.list.length &&
									<button
										className={cx('separator')}
										onClick={this.toggleReaded}
										type='button'
									>
										Просмотренные ранее
									</button>
									}

									<div className={cx('list-readed', {
										'open': this.state.isOpenReaded
									})}>
										{
											this.state.isOpenReaded && notify.list.map((item) => {
												console.log(item)
												console.log('itemmm')
												return (
													<div className={cx('item')} key={item.id}>
														<div className={cx('photo')}>
															<img src={item.photo} alt=""/>
														</div>
														<div className={cx('info')}>
															<div className={cx('header-item')}>
																<span className={cx('text')}>{item.achievement}</span>
																<span className={cx('value')}>{parseInt(item.points) < 0 ? item.points : `+${item.points}`}</span>
															</div>
															<div className={cx('desc')}>{item.text}</div>
															<div className={cx('date')}>{moment(item.createTs).format('lll')}</div>
														</div>
													</div>
												)
											})
										}
									</div>
								</div>
							</div>
						</div>
				}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		isOpen: selectors.isOpen(state),
		notify: selectors.notify(state),
		unReadMessage: selectors.unReadMessage(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		dispatch,
	};
};

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
)(Notifications);


// WEBPACK FOOTER //
// /var/www/build-health-2/src/modules/Notifications/main.js